export const translations = {
  sv: {
    // Navbar
    nav_events: "Events",
    nav_about: "Om oss",
    nav_how: "Så fungerar det",
    nav_contact: "Kontakt",
    nav_request: "Skicka förfrågan",

    // Homepage hero
    hero_tag: "Premium Sportupplevelser",
    hero_title: "Exklusiva VIP-upplevelser",
    hero_subtitle: "Skräddarsydda hospitality-paket för företag, ledningsgrupper & privata kunder.",

    // Featured events
    events_tag: "Utvalda Upplevelser",
    events_title: "Kommande Events",
    from_label: "Från",
    view_label: "Visa",
    pricing_soon: "Pris meddelas snart",

    // Why Serava
    why_tag: "Varför välja oss",
    why_title: "Hospitality,",
    why_title_italic: "på en ny nivå",
    why_desc: "Serava Sports skapar exklusiva upplevelser för kunder som förväntar sig det bästa. Vi går bortom biljetter — och levererar minnesvärda ögonblick byggda på premiumservice och sömlös genomförning.",
    why_curated: "Handplockade premiumevent",
    why_curated_desc: "Utvalda events med världsklass-hospitality. Varje upplevelse är kvalitetssäkrad.",
    why_beyond: "Mer än vanliga biljetter",
    why_beyond_desc: "Loungetillgång, gourmetmiddagar, privata entréer och concierge-service vid varje event.",
    why_corporate: "Perfekt för företag",
    why_corporate_desc: "Imponera på kunder, belöna team och skapa starka affärsrelationer genom delade premiumupplevelser.",
    why_exclusive: "Exklusiv tillgång",
    why_exclusive_desc: "Få tillgång till slutsålda events, begränsade paket och inbjudningsevenemang.",
    why_support: "Personlig support",
    why_support_desc: "Ett dedikerat concierge-team hanterar varje detalj — från bokning till sista farväl.",

    // How it works
    how_tag: "Enkel process",
    how_title: "Så fungerar det",
    how_step1_title: "Bläddra bland events",
    how_step1_desc: "Utforska vårt utbud av premium sport- och underhållningsevent med exklusiva hospitality-alternativ.",
    how_step2_title: "Välj ditt paket",
    how_step2_desc: "Välj ett färdigt VIP-paket eller begär ett skräddarsytt erbjudande för din grupp.",
    how_step3_title: "Säkra din upplevelse",
    how_step3_desc: "Betala säkert online eller prata med vårt concierge-team för att slutföra din bokning.",

    // Newsletter
    news_tag: "Medlemskap",
    news_title: "Få tillgång före",
    news_title_italic: "alla andra",
    news_desc: "Tidig tillgång till nya events, premiummedlemserbjudanden och notiser om slutsålda events.",
    news_placeholder: "Ange din e-post",
    news_btn: "Prenumerera",
    news_subscribing: "Prenumererar...",

    // Trust
    trust_tag: "Betrodda av branschledare",
    trust_title: "Företag, grundare &",
    trust_title_italic: "privata kunder",

    // Contact
    contact_tag: "Kontakta oss",
    contact_title: "Skicka",
    contact_title_italic: "förfrågan",
    contact_desc: "Oavsett om du planerar företagshospitality, en privat VIP-upplevelse eller behöver ett skräddarsytt paket — vårt team är redo att hjälpa.",

    // Footer
    footer_tag: "Redo att uppleva mer?",
    footer_title: "Låt oss skapa din",
    footer_title_italic: "nästa upplevelse",
    footer_nav: "Navigera",
    footer_company: "Företag",
    footer_contact: "Kontakt",
    footer_rights: "Alla rättigheter reserverade.",

    // Event detail
    back_to_events: "Tillbaka till Events",
    about_event: "Om detta event",
    whats_included: "Vad som ingår",
    select_experience: "Välj din upplevelse",
    packages: "Paket",
    schedule: "Schema",
    faq: "Vanliga frågor",
    send_enquiry: "Skicka förfrågan",
    enquiry_desc: "Berätta om dina önskemål så återkommer vi med ett skräddarsytt erbjudande.",
    more_experiences: "Fler upplevelser",
    related_events: "Relaterade Events",
    places: "platser",
    recommended: "Rekommenderad",
    qty: "Antal",
    total: "Totalt",
    pay_card: "Betala med kort",
    request_invoice: "Begär faktura",

    // Event page sections
    event_timeline: "Event-program",
    qa_label: "Frågor & svar",
    interested_label: "Intresserad?",
    enquiry_intro: "Berätta om dina önskemål så återkommer vi med ett skräddarsytt erbjudande.",
    event_not_found: "Eventet hittades inte",
    return_homepage: "Tillbaka till startsidan",
    premium_tagline: "Premium Sports Hospitality",
    about_serava: "Om Serava",
    privacy_policy: "Integritetspolicy",
    terms_of_service: "Användarvillkor",
    cookies: "Cookies",
    privacy: "Integritet",
    terms: "Villkor",

    // Checkout modal
    checkout_title: "Slutför din bokning",
    company_label: "Företag",
    private_label: "Privat",
    company_name: "Företagsnamn *",
    org_number: "Org.nummer *",
    vat_number: "Momsnummer (valfritt)",
    contact_person: "Kontaktperson *",
    full_name: "Fullständigt namn *",
    email: "E-post *",
    phone: "Telefon",
    reference: "Er referens / PO-nummer",
    billing_address: "Fakturaadress",
    street: "Gatuadress",
    zip: "Postnr",
    city: "Stad",
    country: "Land",
    payment_method: "Betalmetod",
    invoice_notes: "Ytterligare information för faktura...",
    proceed_payment: "Gå till betalning",
    submit_invoice: "Skicka fakturaförfrågan",
    processing: "Bearbetar...",

    // Request Access
    request_tag: "Skräddarsydd Upplevelse",
    request_title: "Begär ett anpassat paket",
    request_desc: "Berätta vad du söker så skapar vi en unik hospitality-upplevelse för dig eller ditt företag.",
    request_event_interest: "Vilken typ av event? (t.ex. Fotboll, F1, Gala...)",
    request_guests: "Antal gäster",
    request_budget: "Ungefärlig budget (valfritt)",
    request_message: "Beskriv din drömupplevelse — vad är viktigast för dig? *",
    request_send: "Skicka förfrågan",
    request_sending: "Skickar...",

    // Enquiry form
    enquiry_name: "Fullständigt namn *",
    enquiry_email: "E-postadress *",
    enquiry_phone: "Telefonnummer",
    enquiry_company: "Företagsnamn",
    enquiry_type_label: "Typ av förfrågan",
    enquiry_type_hospitality: "Hospitality-förfrågan",
    enquiry_type_buyer: "Eventköpare",
    enquiry_type_sponsor: "Sponsorintresse",
    enquiry_type_reseller: "Återförsäljare / Agent",
    enquiry_type_general: "Allmän förfrågan",
    enquiry_message: "Berätta om dina önskemål... *",
    enquiry_send: "Skicka förfrågan",
    enquiry_sending: "Skickar...",

    // Checkout success
    payment_processing: "Bearbetar betalning...",
    payment_wait: "Vänta medan vi bekräftar din betalning.",
    payment_confirmed: "Betalning bekräftad",
    payment_thank: "Tack för ditt köp. Din upplevelse är säkrad.",
    receipt: "Kvitto",
    order_number: "Ordernummer",
    event: "Event",
    package: "Paket",
    quantity: "Antal",
    date: "Datum",
    subtotal: "Delsumma",
    billed_to: "Faktureras till",
    receipt_details: "Kvittoinfo",
    payment: "Betalning",
    paid: "Betald",
    download_pdf: "Ladda ner PDF",
    print: "Skriv ut",
    back_to_events_btn: "Tillbaka till Events",
    session_expired: "Sessionen har gått ut",
    something_wrong: "Något gick fel",
    contact_help: "Kontakta oss om du behöver hjälp.",
  },
  en: {
    nav_events: "Events",
    nav_about: "About",
    nav_how: "How It Works",
    nav_contact: "Contact",
    nav_request: "Request Access",

    hero_tag: "Premium Sports Hospitality",
    hero_title: "Curated VIP Experiences",
    hero_subtitle: "Exclusive hospitality packages for companies, executives & private clients.",

    events_tag: "Curated Experiences",
    events_title: "Featured Events",
    from_label: "From",
    view_label: "View",
    pricing_soon: "Pricing announced soon",

    why_tag: "Why Choose Us",
    why_title: "Hospitality,",
    why_title_italic: "Elevated",
    why_desc: "Serava Sports curates exclusive hospitality experiences for discerning clients. We go beyond tickets — delivering memorable moments built on premium service, attention to detail, and seamless execution.",
    why_curated: "Curated Premium Events",
    why_curated_desc: "Hand-selected events with world-class hospitality standards. Every experience is vetted for excellence.",
    why_beyond: "Beyond Standard Tickets",
    why_beyond_desc: "Lounge access, gourmet dining, private entrances, and concierge-level service at every event.",
    why_corporate: "Ideal for Corporate Hosting",
    why_corporate_desc: "Impress clients, reward teams, and create lasting business relationships through shared premium experiences.",
    why_exclusive: "Exclusive Access",
    why_exclusive_desc: "Gain entry to sold-out events, limited-availability packages, and invite-only hospitality experiences.",
    why_support: "Trusted Personal Support",
    why_support_desc: "A dedicated concierge team handles every detail — from booking to the final farewell.",

    how_tag: "Simple Process",
    how_title: "How It Works",
    how_step1_title: "Browse Premium Events",
    how_step1_desc: "Explore our curated selection of premium sports and entertainment events with exclusive hospitality options.",
    how_step2_title: "Choose Your Package",
    how_step2_desc: "Select a ready-made VIP package or request a tailored offer designed specifically for your group.",
    how_step3_title: "Secure Your Experience",
    how_step3_desc: "Pay securely online or speak with our concierge team to finalize your premium booking.",

    news_tag: "Membership",
    news_title: "Get Access Before",
    news_title_italic: "Everyone Else",
    news_desc: "Early access to event releases, premium member alerts, and notifications for sold-out events.",
    news_placeholder: "Enter your email",
    news_btn: "Join",
    news_subscribing: "Subscribing...",

    trust_tag: "Trusted By Industry Leaders",
    trust_title: "Companies, Founders &",
    trust_title_italic: "Private Clients",

    contact_tag: "Get In Touch",
    contact_title: "Request",
    contact_title_italic: "Access",
    contact_desc: "Whether you're planning corporate hospitality, a private VIP experience, or need a custom package — our team is ready to help.",

    footer_tag: "Ready to Experience More?",
    footer_title: "Let's Create Your",
    footer_title_italic: "Next Experience",
    footer_nav: "Navigate",
    footer_company: "Company",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",

    back_to_events: "Back to Events",
    about_event: "About This Event",
    whats_included: "What's Included",
    select_experience: "Select Your Experience",
    packages: "Packages",
    schedule: "Schedule",
    faq: "FAQ",
    send_enquiry: "Send an Enquiry",
    enquiry_desc: "Tell us about your requirements and our team will get back to you with a tailored offer.",
    more_experiences: "More Experiences",
    related_events: "Related Events",
    places: "places",
    recommended: "Recommended",
    qty: "Qty",
    total: "Total",
    pay_card: "Pay with Card",
    request_invoice: "Request Invoice",

    // Event page sections
    event_timeline: "Event Timeline",
    qa_label: "Questions & Answers",
    interested_label: "Interested?",
    enquiry_intro: "Tell us about your requirements and our team will get back to you with a tailored offer.",
    event_not_found: "Event Not Found",
    return_homepage: "Return to homepage",
    premium_tagline: "Premium Sports Hospitality",
    about_serava: "About Serava",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    cookies: "Cookies",
    privacy: "Privacy",
    terms: "Terms",

    checkout_title: "Complete Your Booking",
    company_label: "Company",
    private_label: "Private",
    company_name: "Company Name *",
    org_number: "Org. Number *",
    vat_number: "VAT Number (optional)",
    contact_person: "Contact Person *",
    full_name: "Full Name *",
    email: "Email *",
    phone: "Phone",
    reference: "Your Reference / PO Number",
    billing_address: "Billing Address",
    street: "Street Address",
    zip: "Zip Code",
    city: "City",
    country: "Country",
    payment_method: "Payment Method",
    invoice_notes: "Additional notes for invoice...",
    proceed_payment: "Proceed to Payment",
    submit_invoice: "Submit Invoice Request",
    processing: "Processing...",

    request_tag: "Tailored Experience",
    request_title: "Request a Custom Package",
    request_desc: "Tell us what you're looking for and we'll create a bespoke hospitality experience for you or your company.",
    request_event_interest: "Which event or type of event? (e.g. Football, F1, Gala...)",
    request_guests: "Number of guests",
    request_budget: "Approximate budget (optional)",
    request_message: "Describe your ideal experience — what matters most to you? *",
    request_send: "Send Request",
    request_sending: "Sending...",

    enquiry_name: "Full Name *",
    enquiry_email: "Email Address *",
    enquiry_phone: "Phone Number",
    enquiry_company: "Company Name",
    enquiry_type_label: "Enquiry Type",
    enquiry_type_hospitality: "Hospitality Request",
    enquiry_type_buyer: "Event Buyer",
    enquiry_type_sponsor: "Sponsor Interest",
    enquiry_type_reseller: "Reseller / Agent",
    enquiry_type_general: "General Enquiry",
    enquiry_message: "Tell us about your requirements... *",
    enquiry_send: "Send Enquiry",
    enquiry_sending: "Sending...",

    payment_processing: "Processing Payment...",
    payment_wait: "Please wait while we confirm your payment.",
    payment_confirmed: "Payment Confirmed",
    payment_thank: "Thank you for your purchase. Your experience is secured.",
    receipt: "Receipt",
    order_number: "Order Number",
    event: "Event",
    package: "Package",
    quantity: "Quantity",
    date: "Date",
    subtotal: "Subtotal",
    billed_to: "Billed To",
    receipt_details: "Receipt Details",
    payment: "Payment",
    paid: "Paid",
    download_pdf: "Download PDF",
    print: "Print",
    back_to_events_btn: "Back to Events",
    session_expired: "Session Expired",
    something_wrong: "Something Went Wrong",
    contact_help: "Please contact us if you need assistance.",
  },
};
